import { Component } from '@angular/core';

@Component({
    selector: 'app-gestion-academica',
    templateUrl: './gestion-academica.component.html',
    styleUrls: ['./gestion-academica.component.scss'],
    standalone: false
})
export class GestionAcademicaComponent  {

  

}
